import { module } from 'angular';
import { react2angular } from 'react2angular';
import { SearchResultPods } from './SearchResultPods';

export const SEARCH_RESULT_PODS_COMPONENT = 'spinnaker.core.search.infrastructure.searchResultPods.component';
module(SEARCH_RESULT_PODS_COMPONENT, []).component('searchResultPods', react2angular(SearchResultPods, ['results']));



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./app/scripts/modules/core/src/search/infrastructure/searchResultPods.component.ts